import {ExternalFilters} from './ExternalFilters';

export type FormToDataGridConnectorProps = {
  values: ExternalFilters;
  onChange: (value: ExternalFilters) => void;
};
